import { settingConfiguration } from '../../configurations'
import { CURRENT_PERMISSIONS } from '../../constans'

export * from './constant'
export const hasPermission = (permission) => {
    const permissions = settingConfiguration.get(CURRENT_PERMISSIONS);
    return permissions && permissions.length && permissions.indexOf(permission) >= 0;
}
export default hasPermission